<div class="up-down-container">
  <button class="btn btn-default" (click)="decrement()"><div>–</div></button>
  <div class="value">{{ value }}</div>
  <button class="btn btn-default" (click)="increment()"><div>+</div></button>
</div>
